import Task from "../../../../../lib/html5-software-library/src/ranj/util/executor/Task";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import CharactersConfig from "../model/CharactersConfig";

export default class InitializeCharactersConfigTask extends Task {
    /**
     * @constructor
     * @param {AssetLibrary} assetLibrary 
     * @param {CharactersConfig} charactersConfig
     */
    constructor(assetLibrary, charactersConfig) {
        super();

        this._assetLibrary = assetLibrary;
        this._charactersConfig = charactersConfig;
    }

    execute(callback) {
        const charactersConfigJson = this._assetLibrary.getAsset("charactersConfig");
        this._charactersConfig.setPropertiesFromObject(charactersConfigJson);

        callback(this);
    }
}